var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE3GarageOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.48 27L21 14.28 0 29.11V59h76V27H39.48zM38 55H24v-9h-6v9H4V31.22l17-12 17 11.69V55zm34 0H42V38h30v17zm0-21H42v-3h30v3zm-19.71 6L49 47v5h2v1.48a1.5 1.5 0 103 0V52h7v1.48a1.5 1.5 0 103 0V52h2v-5l-3.29-7H52.29zm-.38 7l1.72-4h7.74l1.73 4H51.91zM32 40h-6v-6h6v6zm-22-6h6v6h-6v-6z",
    fill: "#040404"
  })));
}
export default __webpack_public_path__ + "static/media/E3_Garage_open.d3af059e.svg";
export { SvgE3GarageOpen as ReactComponent };